import { render } from "./BookingsSnippet.vue?vue&type=template&id=2c1087bb"
import script from "./BookingsSnippet.vue?vue&type=script&lang=js"
export * from "./BookingsSnippet.vue?vue&type=script&lang=js"

import "./BookingsSnippet.vue?vue&type=style&index=0&id=2c1087bb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__